<div class="search-button d-flex">
  <img class="pe-2" alt="Magnifier" src="assets/device/magnifier.svg" (click)="toggleSearch()" />
  <input #searchInput type="text" id="searchInput" class="ps-2 pe-2" placeholder="{{ placeholder | translate }}"
    (keydown)="onKeyDown($event)" [(ngModel)]="searchText" (ngModelChange)="handleInputChange($event)"/>
    @if(searchText !== ""){
      <img alt="Exit" src="assets/device/x.svg" (click)="handleInputChange(''); searchInput.focus()" />
    }
</div>
